/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const distinctStatsSchema = z.object({
  reviewed: z.number(),
  expired: z.number(),
  lastPass: z.number(),
  lastFail: z.number(),
});

export type IDistinctStats = z.infer<typeof distinctStatsSchema>;
